import React, { createContext, useState, useContext, useEffect } from 'react';
import en from '../../locales/en.json';
import ml from '../../locales/ml.json';
import kannada from '../../locales/kannada.json';
import Tamil from '../../locales/Tamil.json';
import Hindi from '../../locales/Hindi.json'


const translations: Record<string, any> = { en, ml, Tamil, kannada, Hindi };

//type Lang = 'en' | 'kannada' | 'Tamil' | 'ml' | 'en';

interface LocalizationContextProps {
    language: string;
    setLanguage: (lang: string) => void;
    t: (key: string) => string;
}

const LocalizationContext = createContext<LocalizationContextProps>({
    language: 'en',
    setLanguage: () => { },
    t: (key) => key,
});

export const LocalizationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [language, setLanguageState] = useState<string>('en');

    useEffect(() => {
        const savedLang = localStorage.getItem('language') as string;
        if (savedLang && translations[savedLang]) {
          setLanguageState(savedLang);
        }
      }, []);

      const setLanguage = (lang: string) => {
        localStorage.setItem('language', lang);
        setLanguageState(lang);
      };
    

    const t = (key: string): string => {
        return translations[language][key] || key;
    };

    return (
        <LocalizationContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LocalizationContext.Provider>
    );
};

export const useLocalization = () => useContext(LocalizationContext);
